import React, { Component } from 'react';
import API from '../services/api';
import './Steps.css';
import { Link } from 'react-router-dom';

class Forgot extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      message: '',
      errors: {
        email: '',
      },
    }
  }

  handleFieldChange(e, name) {

    let newState = this.state;
    newState[name] = e.target.value;
    this.setState(newState);
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.state.email.length > 0) {
      (new API()).post(`/users/reset-password`, {email: this.state.email })
        .then(response => {
          if(response.error) {
            this.setState({
              errors: {
                email: response.message,
              }
            })
          } else {
            this.setState({
              message: response.message,
            })
          }
        }).catch((error) => {
            this.setState({
              errors: {
                email: error.message
              }
            });
      });
    }else{
      this.setState({
        errors: {
          email: 'Email must be filled.'
        }
      })
    }
  }

  render() {
    const { errors, message } = this.state;
    return (
      <div className="container">
        <div className="intro">
          <h1>UPPERCLASSDATES</h1>
          <div className="subtitle">
            Reset your password
          </div>
        </div>
        <form className="forgot">
          <div className="Step Step-container active">
            <div className="Step-title">
              Password reset
            </div>
            {message.length === 0 && <div className="Step-intro">
              Enter the email address that you used to registered with us, and we'll send you instructions for resetting your password.
            </div>}
            {message.length > 0 && <div className="Step-intro">
              {message}
            </div>}
            {message.length === 0 && <div className="field-container text open">
              <div className="field-title">Email Address:</div>
              <div className="row">
                <div className="col">
                  <input onChange={e => this.handleFieldChange(e, e.target.name)} type="text" name="email" placeholder="Your email..." />
                  {errors.email.length > 0 && <span className="error">{errors.email}</span>}
                </div>
              </div>
            </div>}
            {message.length === 0 && <div className="row button-container left space-between">
              <div className="col">
                <button
                  className="btn btn-primary"
                  onClick={(e) => this.handleSubmit(e)}
                >
                  Reset
                </button>
                <Link to="/login">Back to login</Link>
              </div>
            </div>}
          </div>
        </form>
        <div className="texts">
          <div className="row">
            <div className="col center">
              Don't have an account yet? <Link to="/join">Join</Link> now.
            </div>
          </div>
          <div className="row">
            <div className="col">
              <p>
                By continuing you agree to UpperClassDates' <a href="https://upperclassdates.com/privacy-statement/">Privacy Policy</a>.
              </p>
              <p>
                Prostitution and promotion of other commercial activities is prohibited.
              </p>
              <p>
                Are you an escort?, then don't use this website.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Forgot;


// WEBPACK FOOTER //
// ./src/components/Forgot.js